/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SandboxPriceRate,
  SandboxPriceRate$inboundSchema,
  SandboxPriceRate$Outbound,
  SandboxPriceRate$outboundSchema,
} from "./sandboxpricerate.js";

/**
 * Full-replace rate card update; omitted SKUs become unpriced.
 */
export type SandboxPricingUpdate = {
  rates: { [k: string]: SandboxPriceRate };
};

/** @internal */
export const SandboxPricingUpdate$inboundSchema: z.ZodType<
  SandboxPricingUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  rates: z.record(SandboxPriceRate$inboundSchema),
});
/** @internal */
export type SandboxPricingUpdate$Outbound = {
  rates: { [k: string]: SandboxPriceRate$Outbound };
};

/** @internal */
export const SandboxPricingUpdate$outboundSchema: z.ZodType<
  SandboxPricingUpdate$Outbound,
  z.ZodTypeDef,
  SandboxPricingUpdate
> = z.object({
  rates: z.record(SandboxPriceRate$outboundSchema),
});

export function sandboxPricingUpdateToJSON(
  sandboxPricingUpdate: SandboxPricingUpdate,
): string {
  return JSON.stringify(
    SandboxPricingUpdate$outboundSchema.parse(sandboxPricingUpdate),
  );
}
export function sandboxPricingUpdateFromJSON(
  jsonString: string,
): SafeParseResult<SandboxPricingUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SandboxPricingUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SandboxPricingUpdate' from JSON`,
  );
}
